import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AdministracionNuevoCoreAPIConstant } from "src/app/constants/configuracion/menus/administracion-menu.constant";
import { CrearMenuDTO } from "src/app/dtos/menus/crear-menu.dto";
import { ItemFiltroPrivilegioDTO } from "src/app/dtos/menus/item-flitro-privilegio.dto";
import { MenuNuevoDTO } from "src/app/dtos/menus/menuNuevo.dto";
import { ParentsMenuDTO } from "src/app/dtos/menus/parents-menu.dto";
import { PrivilegioMenuDTO } from "src/app/dtos/menus/privilegio-menu.dto";
import { FiltroBusquedaNuevoDTO } from "src/app/dtos/solicitudes/filtro-busqueda-nuevo.dto";
import { MessageResponseDTO } from "src/app/dtos/transversal/message-response.dto";
import { PaginadorResponseDTO } from "src/app/dtos/transversal/paginador-response.dto";
import { QueryParamsConverterService } from "src/app/modules/shared/services/query-params-converter.service";


@Injectable({ providedIn: 'root' })
export class MenuApiService {


  constructor(private http: HttpClient, private queryParamsConverterService:QueryParamsConverterService) { }


  public getMenusNuevo(
        filtro: FiltroBusquedaNuevoDTO
      ): Observable<PaginadorResponseDTO> {
        let data = this.queryParamsConverterService.convertDtoToHttpParams(filtro);
        return this.http.get<PaginadorResponseDTO>(`${AdministracionNuevoCoreAPIConstant.URL_GET_MENUS}`, { params: data })
  }
  public getMenuNuevoId(
        id: String
      ): Observable<MenuNuevoDTO> {
        return this.http.get<MenuNuevoDTO>(`${AdministracionNuevoCoreAPIConstant.URL_GET_MENUS}/${id}`)
  }

  public getAccionesByMenuAndRole(params: {roles: Array<number>, menuId: number}): Observable<any> {
    return this.http.get<any>(`${AdministracionNuevoCoreAPIConstant.URL_GET_SELECT_ITEMS}/menu?roles=${params.roles}&menuId=${params.menuId}`);
  }

  public getSelectItemsPrivilige(params: ItemFiltroPrivilegioDTO): Observable<PrivilegioMenuDTO[]> {
    let data = this.queryParamsConverterService.convertDtoToHttpParams(params);

    return this.http.get<PrivilegioMenuDTO[]>(`${AdministracionNuevoCoreAPIConstant.URL_GET_SELECT_ITEMS}`,{ params: data });
  }
  public getSelectItemsParents(params:any): Observable<ParentsMenuDTO[]> {
    let data = this.queryParamsConverterService.convertDtoToHttpParams(params);

    return this.http.get<ParentsMenuDTO[]>(`${AdministracionNuevoCoreAPIConstant.URL_GET_SELECT_ITEMS_PARENTS}`,{ params: data });
  }
  public getResourcesByParent(
    parentId: number | null,
    application: string,
    companyId: number
  ): Observable<any[]> {
    const params =
      parentId == null ? { application, companyId } : { parentId };
    const data = this.queryParamsConverterService.convertDtoToHttpParams(params);
    return this.http.get<any[]>(
      `${AdministracionNuevoCoreAPIConstant.URL_GET_MENUS}/children`,
      { params: data }
    );
  }

  public crearMenu(menu: CrearMenuDTO) {
    return this.http.post<any>(
      AdministracionNuevoCoreAPIConstant.URL_CREAR_MENU,
      menu
    );
  }

  public editarMenu(menu: CrearMenuDTO, id: number): Observable<MessageResponseDTO> {
    return this.http.put<MessageResponseDTO>(
      `${AdministracionNuevoCoreAPIConstant.URL_EDITAR_MENU}/${id}`,
      menu
    );
  }

  public editarMenuStatus(status: string, id: number): Observable<MessageResponseDTO> {
    const data = {};
    return this.http.patch<MessageResponseDTO>(
      `${AdministracionNuevoCoreAPIConstant.URL_EDITAR_MENU}/${id}?status=${status}`,
      { data }
    );
  }
}
